export default {
  stream: {
    zh: '流管理',
    en: 'Stream',
  },
  source: {
    zh: '源管理',
    en: 'Source',
  },
  createStream: {
    zh: '创建流',
    en: 'Create stream',
  },
  viewStream: {
    zh: '查看流',
    en: 'View stream',
  },
  streamName: {
    zh: '流名称',
    en: 'Stream Name',
  },
  streamType: {
    zh: '流类型',
    en: 'Stream Type',
  },
  isSchemaType: {
    zh: '是否为带结构的流',
    en: 'Whether the schema stream',
  },
  schemaTip: {
    zh: `自定义流字段结构，\n例如对应 SQL 语句中的：\n(
        USERID BIGINT,
        FIRST_NAME STRING,
        LAST_NAME STRING,
        NICKNAMES ARRAY(STRING),
        Gender BOOLEAN,
        ADDRESS STRUCT(
            STREET_NAME STRING,
            NUMBER BIGINT
        ),
    )`,
    en: `Custom stream fields, \nE.g the SQL statement:\n(
        USERID BIGINT,
        FIRST_NAME STRING,
        LAST_NAME STRING,
        NICKNAMES ARRAY(STRING),
        Gender BOOLEAN,
        ADDRESS STRUCT(
            STREET_NAME STRING,
            NUMBER BIGINT
        ),
    )`,
  },
  sqlRequired: {
    zh: '请输入 SQL',
    en: 'SQL is required',
  },
  dataSource: {
    zh: '数据源',
    en: 'Data Source',
  },
  format: {
    zh: '流格式',
    en: 'Stream Format',
  },
  key: {
    zh: '主键',
    en: 'Key',
  },
  streamFields: {
    zh: '流字段',
    en: 'Stream Fields',
  },
  sourceConfig: {
    zh: '源配置',
    en: 'Source Config',
  },
  fieldType: {
    zh: '字段类型',
    en: 'Field Type',
  },
  typeFirst: {
    zh: '请先选择流类型',
    en: 'Please select Stream Type first',
  },
  addField: {
    zh: '添加流字段',
    en: 'Add stream field',
  },
  arrayType: {
    zh: '数组类型',
    en: 'Array Type',
  },
  streamNameSpace: {
    zh: '流名称不能包含空格',
    en: 'Stream Name can not contain space characters',
  },
  shared: {
    zh: '共享',
    en: 'Shared',
  },
  schema: {
    zh: '模式',
    en: 'Schema',
  },
  schemaMessage: {
    zh: '模式消息',
    en: 'Schema Message',
  },
  schemaName: {
    zh: '模式名称',
    en: 'Schema Name',
  },
  fileName: {
    zh: '文件名称',
    en: 'File Name',
  },
  endPoint: {
    zh: '端点',
    en: 'End Point',
  },
  topic: {
    zh: '主题',
    en: 'Topic',
  },
  deleteStreamWarning: {
    zh: '所有使用该流的规则将继续使用被删除的配置运行，直到重新启动，如果不正确，请手动停止它们。',
    en: 'All rules using this stream will continue to run with the deleted configuration until restart, if it is not correct, please stop them manually.',
  },
  delimited: {
    zh: '分隔符',
    en: 'Delimited',
  },
  timestamp: {
    zh: '时间戳字段',
    en: 'Timestamp Field',
  },
  timestampDesc: {
    zh: '指定哪个字段表示事件时间',
    en: 'Specify which field in the event represent the timestamp',
  },
  timestampFormat: {
    zh: '时间戳格式',
    en: 'Timestamp Foramt',
  },
}
